import React, { useEffect, useRef, useState } from 'react';

const SubregionCreationPopup = ({ onClose}) => {
  const popupRef = useRef(null);
  useEffect(() => {
    popupRef.current?.focus();
  }, []);

  const optionsList = [
    { id: 1, name: '1x1', width: 1, height: 1, bed: false, door: false },
    { id: 2, name: 'Letto', width: 1, height: 2, bed: true, door: false },
    { id: 3, name: 'Letto or.', width: 2, height: 1, bed: true, door: false },
    { id: 4, name: 'Porta', width: 0.2, height: 1, bed: false, door: true },
    { id: 5, name: 'Porta or.', width: 1, height: 0.2, bed: false, door: true },
  ];
  const [selectedValue, setSelectedValue] = useState(0);
  const [inputText, setInputText] = useState('');
  
  const handleConfirm = () => {
    const selectedObject = optionsList[selectedValue];
    onClose({ selected: selectedObject, label: inputText });
  };

  return (
    <>
      {/* Backdrop */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.4)',
          zIndex: 9998,
        }}
      />

      {/* Modal box */}
      <div
        ref={popupRef}
        tabIndex={-1}
        style={{
          position: 'fixed',
          top: '30%',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: 'white',
          border: '1px solid #ccc',
          padding: '1em',
          zIndex: 9999,
          boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
          outline: 'none',
        }}
      >
        <p>Scegli una sottoregione:</p>

        <div style={{ display: 'flex', gap: '0.5em', marginBottom: '1em' }}>
            <select
                value={selectedValue}
                onChange={(e) => setSelectedValue(e.target.value)}
            >
                {optionsList.map((opt, idx) => (
                    <option key={opt.id} value={idx}>
                        {opt.name}
                    </option>
                ))}
            </select>

            <input
                type="text"
                placeholder="Label"
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
            />
        </div>

        <button onClick={handleConfirm}>Confirm</button>
        <button onClick={() => onClose(null)}>Cancel</button>
      </div>
    </>
  );
};

export default SubregionCreationPopup;
